import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityLicenseInfoProps {
  community_id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityLicenseInfo = async (ID: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/license-info`);

const useGetCommunityLicenseInfo = ({
  community_id,
  queryParams,
}: UseGetCommunityLicenseInfoProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-license-info", community_id],
    queryFn: () => getCommunityLicenseInfo(community_id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!community_id && (queryParams?.enabled ?? true),
  });
};

export default useGetCommunityLicenseInfo;
